module.exports = __webpack_public_path__ + "media/images/common/search/icon-station-05858f5bea71e0b60e435954a4fe5aed.png";